import { SharedFuncReference } from "@/utils/shared-func-reference";
import { v4 } from "uuid";
import { FrontendFuncParam } from "./frontend-func-param";

export enum FrontendFuncType {
	AutoSaleRow = "auto-sale-row"
}

export class FrontendFunc {
	static readonly validNameRegex = /^[a-zA-Z][a-zA-Z0-9]*$/;

	id:string = v4();
	ID:number = 0;
	Name:string = "newFunc";
	Code:string = "";
	Description:string = "Niewue functie zonder code";
	Type:FrontendFuncType = FrontendFuncType.AutoSaleRow;
	Params:FrontendFuncParam[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Name = data.Name;
		this.Code = data.Code;
		this.Description = data.Description;
		this.Params = (data.Params || []).map((d:any)=>new FrontendFuncParam(d));
		this.Type = data.Type;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Name: this.Name.trim(),
			Code: this.Code,
			Description: this.Description,
			Params: this.Params.map(p=>p.getJSON()),
			Type: this.Type
		};
	}

	toSharedFuncReference():SharedFuncReference{
		let ref = new SharedFuncReference();
		ref.FuncID = this.ID;
		ref.Alias = this.Name;
		ref.SharedFunc = this;
		return ref;
	}

}